var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(this.currentStyle()),attrs:{"id":"loading"}})
}
var staticRenderFns = []

export { render, staticRenderFns }